<template>
    <scheduled-loads :loads="scheduledLoads"
                     @refresh="$emit('refresh')"
                     :company="company"
                     @updateLoad="$emit('updateLoad', $event)"
                     :status="loadStatus.SCHEDULED">
    </scheduled-loads>
</template>

<script>
import ScheduledLoads from '@/components/dashboard/simple/ScheduledLoads';
import filterLoads from '@/mixins/filterLoads';
import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import loadsRoutingMixin from '@/mixins/loadsRoutingMixin';

export default {
  name: 'Schedule',
  mixins: [
    filterLoads,
    bookedLoadMixin,
    loadsRoutingMixin,
  ],
  components: {
    ScheduledLoads,
  },
  props: {
    company: {
      type: Object,
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  data: () => ({
    search: null,
    loadingBtn: false,
    mobileSortOptions: [
      { text: 'Sort ascending by Pickup Date', value: 'pickup_asc' },
      { text: 'Sort descending by Pickup Date', value: 'pickup_desc' },
      { text: 'Sort ascending by driver', value: 'driver_asc' },
      { text: 'Sort descending by driver', value: 'driver_desc' },
    ],
  }),
  beforeRouteLeave(to, from, next) {
    // Before leave save id in local storage
    const sectionKey = `${from.name}_bookedLoadId`;
    if (this.bookedLoadId) {
      localStorage.setItem(sectionKey, this.bookedLoadId);
    } else {
      localStorage.removeItem(sectionKey);
    }
    next();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Receiving/Schedule.vue